
(function($) {

    $(document).ready(function () {

        if ($('.portfolio-slider-swiper').length) {

            var portfolioSlider = new Swiper ('.portfolio-slider-swiper', {
                slidesPerView: 1,
                spaceBetween: 30,
                slidesOffsetAfter: 0,
                speed: 600,
                pagination: {
                    el: '.portfolio-slider-swiper .swiper-pagination',
                    type: 'fraction',
                },
                navigation: {
                    nextEl: '.portfolio-slider-swiper .swiper-button-next',
                    prevEl: '.portfolio-slider-swiper .swiper-button-prev',
                },
                breakpoints: {
                    // when window width is >= 680
                    850: {
                        slidesPerView: 3,
                        slidesOffsetAfter: 0
                    }
                }
            });

            $(window).on('resize', function() {
                portfolioSlider.update();
            });

            $('.portfolio-slider-nav li').on('click', function() {
                var $this = $(this);
                var locationTarget = $this.data('location-target');

                $this.closest('.portfolio-slider-nav').addClass('disabled');

                $this.siblings().removeClass('active');
                $this.addClass('active');

                $(portfolioSlider.el).addClass('overlay');

                $(portfolioSlider.el).one('transitionend', function() {
                    if (locationTarget === 'all') {
                        $(portfolioSlider.slides).show();
                        portfolioSlider.update();
                    }

                    else {
                        $(portfolioSlider.slides).show();
                        $(portfolioSlider.slides).not('[data-location="'+ locationTarget +'"]').hide();
                        portfolioSlider.update();
                    }

                    setTimeout(function() {
                        $(portfolioSlider.el).removeClass('overlay');
                        $this.closest('.portfolio-slider-nav').removeClass('disabled');
                    }, 300);
                });

            });

        }

    });

})( jQuery );